import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";
import Monogram from "@/components/Monogram";

const BRIDAL_IMG_1 =
  "https://images.unsplash.com/photo-1606143412458-acc5f86de897?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHw0fHxlZGl0b3JpYWwlMjBiZWF1dHklMjBwb3J0cmFpdCUyMG5ldXRyYWx8ZW58MHx8fHwxNzgyMTE1ODg5fDA&ixlib=rb-4.1.0&q=85";
const BRIDAL_IMG_2 =
  "https://images.unsplash.com/photo-1612196808827-9ff25cb6137a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxuZXV0cmFsJTIwaW50ZXJpb3IlMjBtaW5pbWFsJTIwc3VubGlnaHR8ZW58MHx8fHwxNzgyMTE1ODg5fDA&ixlib=rb-4.1.0&q=85";
const BRIDAL_IMG_3 =
  "https://images.unsplash.com/photo-1533933269825-da140ad3132f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwzfHxlZGl0b3JpYWwlMjBiZWF1dHklMjBwb3J0cmFpdCUyMG5ldXRyYWx8ZW58MHx8fHwxNzgyMTE1ODg5fDA&ixlib=rb-4.1.0&q=85";

export default function Bridal() {
  return (
    <>
      <section className="pt-44 pb-16 px-6 lg:px-14 bg-[#F5F2ED] relative overflow-hidden">
        <Monogram size={720} opacity={0.05} color="#4A3E39" className="absolute -left-60 top-0 hidden md:block" />
        <div className="max-w-[1500px] mx-auto">
          <Reveal>
            <div className="eyebrow mb-6">Bridal Atelier</div>
            <h1 className="font-display font-light text-ivory-800 text-6xl md:text-8xl lg:text-[120px] leading-[0.95] max-w-5xl">
              The bride, <em className="italic">undecorated</em>.
            </h1>
            <p className="mt-10 max-w-xl text-[15px] leading-[1.9] text-ivory-700">
              A small, three-day atelier devoted entirely to weddings. We do not arrive with kits.
              We arrive with a notebook.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="px-6 lg:px-14 py-20 lg:py-32 bg-[#F5F2ED]">
        <div className="max-w-[1500px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
          <Reveal className="lg:col-span-5">
            <div className="zoom-wrap aspect-[4/5] overflow-hidden">
              <img src={BRIDAL_IMG_1} alt="" className="zoom-img w-full h-full object-cover" />
            </div>
          </Reveal>
          <Reveal className="lg:col-span-4 lg:col-start-7" delay={120}>
            <p className="font-display italic text-ivory-800 text-3xl md:text-4xl leading-tight">
              We do not design brides. We design the people they already are, only slightly more lit.
            </p>
          </Reveal>
          <Reveal className="lg:col-span-7 lg:row-start-2 mt-20" delay={80}>
            <div className="zoom-wrap aspect-[16/9] overflow-hidden">
              <img src={BRIDAL_IMG_3} alt="" className="zoom-img w-full h-full object-cover" />
            </div>
          </Reveal>
          <Reveal className="lg:col-span-4 lg:col-start-9 lg:row-start-2 mt-20 lg:mt-0" delay={140}>
            <div className="space-y-5 text-[15px] leading-[1.9] text-ivory-700">
              <p>
                Bridal work, at Ivory, begins three to four months before the wedding. We meet over
                tea, look at your photographs as a child, your mother&rsquo;s wedding album, and the
                clothes you have already chosen.
              </p>
              <p>
                We build a single, consistent visual language for the three or four days of your
                wedding — never a different bride for each event.
              </p>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="bg-[#EEE7DE] py-28 lg:py-40 px-6 lg:px-14">
        <div className="max-w-[1500px] mx-auto">
          <Reveal>
            <div className="eyebrow mb-8">The Programmes</div>
          </Reveal>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 lg:gap-20">
            {[
              { t: "The Engagement Look", p: "₹ 22,000", d: "A single-day look — hair, makeup, light skin prep. For roka, engagement and intimate ceremonies." },
              { t: "The Bridal Atelier (Day)", p: "₹ 65,000", d: "One full day of bridal work — sangeet, mehendi, or wedding. Lead artist, second artist, and a hair specialist on call." },
              { t: "The Three-Day Edit", p: "₹ 1,40,000", d: "Three consecutive days. Continuous visual language. Includes wardrobe consult and on-site touch-ups." },
              { t: "Pre-Wedding Skin Programme", p: "₹ 38,000", d: "A four-month programme of consultations and gentle treatments, designed to land your skin on the day, calmly." },
            ].map((s) => (
              <Reveal key={s.t}>
                <div className="border-b border-[#B7AB9B]/60 pb-8">
                  <div className="flex items-end justify-between gap-6">
                    <h3 className="font-display text-ivory-800 text-3xl md:text-4xl leading-tight">{s.t}</h3>
                    <span className="font-mono text-[13px] text-ivory-700 whitespace-nowrap">{s.p}</span>
                  </div>
                  <p className="mt-5 text-[15px] leading-[1.85] text-ivory-700 max-w-md">{s.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal>
            <div className="mt-16">
              <Link to="/book" data-testid="bridal-book-cta" className="btn-burgundy">Begin a bridal consultation</Link>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="relative h-[70vh] min-h-[480px] overflow-hidden">
        <img src={BRIDAL_IMG_2} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#2C2724]/35" />
      </section>
    </>
  );
}
